"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createObjectUnpacker = void 0;
var ObjectUnpackerImpl_1 = require("./ObjectUnpackerImpl");
var createObjectUnpacker = function () {
    return new ObjectUnpackerImpl_1.ObjectUnpackerImpl();
};
exports.createObjectUnpacker = createObjectUnpacker;
//# sourceMappingURL=ObjectUnpacker.js.map